import { ThemedText } from "@/components/ThemedText";
import { View } from "react-native";
import { PayrollType } from "@/types/db/payroll";

type PayrollOverviewTabProps = {
  payroll: PayrollType | null;
  loading: boolean;
};

export function PayrollOverviewTab({ payroll, loading }: PayrollOverviewTabProps) {
  if (loading) {
    return (
      <View style={{ padding: 16 }}>
        <ThemedText>Loading payroll entry...</ThemedText>
      </View>
    );
  }

  if (!payroll) {
    return (
      <View style={{ padding: 16 }}>
        <ThemedText>No payroll data available</ThemedText>
      </View>
    );
  }

  return (
    <View style={{ padding: 16 }}>
      <ThemedText type="subtitle">Payroll Entry Overview (Placeholder)</ThemedText>
      <ThemedText>ID: {payroll.id}</ThemedText>
      <ThemedText>User: {payroll.user_id || "N/A"}</ThemedText>
      <ThemedText>Amount: ${payroll.amount || 0}</ThemedText>
      <ThemedText>Status: {payroll.status || "N/A"}</ThemedText>
      <ThemedText>
        Period: {payroll.period_start ? new Date(payroll.period_start).toLocaleDateString() : "N/A"} -{" "}
        {payroll.period_end ? new Date(payroll.period_end).toLocaleDateString() : "N/A"}
      </ThemedText>
    </View>
  );
}
